import { Box } from '@mui/material'
import cn from 'classnames'
import s from './BooleanIconText.modules.scss'
import { BooleanIconTextProps } from './BooleanIconTextDefinitions'

const BooleanIconText = (props: BooleanIconTextProps) => {
  const {
    value,
    successIcon,
    failureIcon,
    neutralIcon,
    isSuccess,
    isFailure,
    isNeutral,
    size = 'medium',
    style,
    onClick
  } = props

  return (
    <Box
      className={cn(
        s.container,
        { [s.success]: isSuccess },
        { [s.failure]: isFailure },
        { [s.neutral]: isNeutral },
        { [s.small]: size === 'small' },
        { [s.medium]: size === 'medium' },
        { [s.large]: size === 'large' }
      )}
      style={style}
      onClick={onClick}
    >
      {!!isSuccess && successIcon}
      {!!isFailure && failureIcon}
      {!!isNeutral && neutralIcon}
      {value}
    </Box>
  )
}

export default BooleanIconText
